<div id="img-cont" class="dsk">
  <img src="../../../assets/JAIPUR.png" alt="" class="logo-inc" />
</div>

<div class="glass"></div>
<div id="mb-logos" class="mb" style="z-index: 2" ></div>
